var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.versionShow,
          expression: "versionShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "backupVersion" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("language.cloudBackup.versions")) +
              "\n            "
          ),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          })
        ]),
        _vm._v(" "),
        !_vm.notRunShow
          ? _c("div", { staticClass: "backversion-title" }, [
              _c("span", { staticClass: "version-line" }, [
                _vm._v(_vm._s(_vm.$t("language.cloudBackup.backupTime")))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "version-line" }, [
                _vm._v(_vm._s(_vm.$t("language.cloudBackup.changedFiles")))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "version-right" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "backupVersion-body" },
          [
            _vm._l(_vm.versions, function(item, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.notRunShow,
                      expression: "!notRunShow"
                    }
                  ],
                  key: index,
                  staticClass: "backversion-line",
                  class: _vm.hoverIndex == index ? "version-back" : "",
                  on: {
                    mouseleave: function($event) {
                      _vm.hoverIndex = -1
                    },
                    mouseenter: function($event) {
                      _vm.hoverIndex = index
                    }
                  }
                },
                [
                  _c("span", { staticClass: "version-line" }, [
                    _vm._v(
                      _vm._s(_vm._f("transferForMatTime")(item.createTime))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "version-line" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.cloudBackup.inTotalTip", {
                          count: item.updateInfo.conut,
                          size: _vm.formatLogByte(item.updateInfo.size)
                        })
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.hoverIndex == index
                    ? _c("span", { staticClass: "version-right" }, [
                        _c(
                          "button",
                          {
                            staticStyle: { "margin-top": "5Px" },
                            on: {
                              click: function($event) {
                                return _vm.openRestore(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudExploer.restore"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "version-delete-icon",
                          staticStyle: {
                            float: "right",
                            position: "relative",
                            top: "10Px",
                            cursor: "pointer"
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteVersion(item)
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.notRunShow,
                    expression: "notRunShow"
                  }
                ],
                staticStyle: { position: "relative", top: "20Px" }
              },
              [
                _vm._v(
                  "\n                          " +
                    _vm._s(_vm.$t("language.cloudSync.notRun")) +
                    "\n                     "
                )
              ]
            )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9ca9eca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9ca9eca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/list_versions_popup.vue
// module id = null
// module chunks = 